import React from 'react';
import Button from './ui/Button';

class ErrorBoundary extends React.Component {
 constructor(props) {
 super(props);
 this.state = { hasError: false, error: null };
 }

 static getDerivedStateFromError(error) {
 return { hasError: true, error };
 }

 componentDidCatch(error, errorInfo) {
 console.error('Error caught by boundary:', error, errorInfo);
 }

 render() {
 if (this.state.hasError) {
 return (
 <div className="flex items-center justify-center min-h-screen bg-background p-4">
 <div className="max-w-md w-full bg-background border border-border p-6 text-center">
 <div className="text-4xl mb-4">⚠️</div>
 <h1 className="text-2xl font-medium mb-2 text-foreground">Something went wrong</h1>
 <p className="text-muted-foreground mb-4">
 An unexpected error occurred. Please try refreshing the page.
 </p>
 {this.state.error && (
 <details className="text-left mb-4 p-3 bg-background text-sm">
 <summary className="cursor-pointer font-medium mb-2">Error details</summary>
 <code className="text-xs">{this.state.error.toString()}</code>
 </details>
 )}
 <Button
 onClick={() => window.location.reload()}
 className="w-full"
 >
 Reload Page
 </Button>
 </div>
 </div>
 );
 }

 return this.props.children;
 }
}

export default ErrorBoundary;
